/* eslint  react/jsx-no-bind:0 */
import React from "react"
import { Route } from "react-router-dom"
//import LandingPage from '../pages/LandingPage'
import Dashboard from "../pages/Dashboard"
import EventPage from "../pages/Event"
import EventResult from "../pages/EventResult"
import RankingSetup from "../pages/RankingSetup"
import Ranking from "../pages/Ranking"
import Athlete from "../pages/Athlete"
import Reconciliation from "../pages/Event/Reconciliation"
import Membership from "../pages/VerifyMembership"
import Exception from "../pages/Exception"
import Reports from "../pages/Report"
import Statistics from "../pages/Statistics"
//import Register from "../pages/RegistrationInvitation"
import UserManagement from "../pages/UserManagement"
import LastRun from "../../containers/ranking/LastRun"
import UpcomingEvent from "../../containers/event/upcomingevent"
import SeasonSettings from "../../containers/season/SeasonSettings"
import Base from "./Base"
import ModalRoot from "./ModalRoot"

const IndexPage = () => (
 
  <Base>
    <Route path="/dashboard" component={Dashboard} />
    <Route exact path="/event" component={EventPage} />
    <Route exact path="/events/:id" component={EventPage} /> 
    <Route path="/results" component={EventResult} />
    <Route path="/ranking" component={Ranking} />
    <Route path="/eligibility" component={Membership} />
    <Route path="/exceptions" component={Exception} />
    <Route path="/rankingsetup" component={RankingSetup} />
    <Route path="/reports" component={Reports} />
    <Route path="/statistics" component={Statistics} />
    <Route path="/usermanagement" component={UserManagement} />
    <Route path="/lastrun" component={LastRun} />
    <Route path="/upcomingevents" component={UpcomingEvent} />
    {/* <Route path="/register" component={Register} />  */}
    <Route path="/seasonsettings" component={SeasonSettings} />
    <Route path="/athleteprofile" component={Athlete} />
    <Route exact path="/reconciliation/:eventId/:action" component={Reconciliation} />
    <Route exact path="/reconciliation" component={Reconciliation} />
   
    <Route path="/" exact component={Dashboard} />
    <ModalRoot />
  </Base>
)
export default IndexPage


// WEBPACK FOOTER //
// ./src/components/layout/IndexPage.js